<template xmlns="http://www.w3.org/1999/html">
  <div class="contractContainer darkMode">
    <div class="rate darkMode">
      <span class="rateItem darkMode active"
            style="color: rgba(128, 128, 128, 1);background: rgba(43, 43, 43, 1)">{{ $t('full_position') }}</span>
      <span class="rateItem active darkMode" style="background: rgba(56, 56, 56, 1);color: rgba(255, 255, 255, 1)"
            @click="openLevel">{{ levelMap[underling] }}x</span>
    </div>
    <div class="openC">
      <div class="openItem open darkMode">
        <span :class="'openItemTitle openTitle darkMode '+ (isOpen?'active':'')"
              @click="isOpen=true">{{ $t("open_position") }}</span>
      </div>
      <div class="openItemBox darkMode"></div>
      <div class="openItem close darkMode">
        <span :class="'openItemTitle closeTitle darkMode '+(!isOpen?'active':'')"
              @click="isOpen=false;">{{ $t("close_position") }}</span>
      </div>
    </div>
    <div class="openType darkMode">
      <span :class="'type darkMode '+ (marketType==0?'active':'')" @click="marketType=0;">{{ $t('limit_price') }}</span>
      <span :class="'type darkMode '+ (marketType==1?'active':'')" @click="marketType=1;">{{ $t('market_price') }}</span>
      <span v-if="!isOpen" :class="'type darkMode '+ (marketType==2?'active':'')" @click="marketType=2;">{{$t('take_profit_stop_loss')}}</span>
    </div>

    <div class="limitC darkMode" v-show="marketType==0">
      <div class="titleC darkMode">
        <div class="avaTitle darkMode">
          {{$t('current_price')}}
          <span class="avaValue darkMode"> {{currentPrice}}</span>
        </div>
      </div>
      <div class="amountC darkMode downlist">
        <drawer_list :title="$t('trading_pair')" width="60px" :change-title="false" :on-select="(item,key)=>this.changeUnderline(item,0)" :list="['BTC','ETH','SOL']" :default-select="0" ></drawer_list>
        <div class="amountContent">{{limitUnderline}}</div>
      </div>
      <div class="inputC darkMode">
        <div class="inputCC darkMode">
<!--          <div class="title">{{$t('order_price2')}}</div>-->
          <input class="input darkMode" :placeholder="$t('order_price2')" min=0 value="" type="number" v-model="limitPrice"/>
          <span class="unit darkMode"></span>
        </div>
        <div class="newPrice darkMode" @click="limitPrice=currentPrice">
          {{ $t("latest_price") }}
        </div>
      </div>
      <div class="amountC darkMode">
<!--        <div class="title">{{ isOpen ? $t("open_quantity") : $t("close_quantity") }}</div>-->
        <input class="amountIn darkMode" :placeholder='isOpen ? $t("open_quantity") : $t("close_quantity")' value="" v-model="limitAmount" @focus="getFocus(1)"
        />
        <span class="amountTitle darkMode">{{ underling }}</span>
      </div>
      <draggable-progress v-model="progressLimit" :content="['0','100%']"/>

      <div :class="'buySellNotice darkMode ' + (showLimitProgressNum?'':'willHide')">
        <div class="item darkMode">
          <div><span>{{ isOpen ? $t("openable") : $t("closable") }}</span><span
              class="span darkMode">{{ isOpen ? limitAmountNumber : transBig2number(closeLongAmountLimit) }} {{ underling }}</span>
          </div>
        </div>
        <div class="item darkMode">
          <div>{{ isOpen ? $t("openable") : $t("closable") }}<span
              class="span darkMode">{{ isOpen ? limitAmountNumber : transBig2number(closeShortAmountLimit) }} {{ underling }}</span>
          </div>
        </div>
      </div>

      <div class="confirmBox darkMode">
        <input class="confirmBuy darkMode" type="submit" @click="open(true,true)"
               :value="isOpen?$t('go_long'):$t('close_long')"/>
        <input class="confirmSell darkMode" type="submit"
               :value="isOpen?$t('go_short'):$t('close_short')" @click="open(false,true)"/>
      </div>

      <div :class="'priceC darkMode'">
        <div class="priceCC darkMode">
          <div class="darkMode">
            <span class="price darkMode">{{ isOpen ? $t("max_openable") : $t("max_closable") }}</span>
            <span
                class="priceV darkMode">{{ isOpen ? maxLimit : transBig2number(maxLong) }} {{ underling }}</span>
          </div>
          <div class="closeC darkMode">
            <span class="price darkMode">{{ isOpen ? $t("max_openable") : $t("max_closable") }}</span>
            <span
                class="priceV darkMode">{{ isOpen ? maxLimit : transBig2number(maxShort) }} {{ underling }}</span>
          </div>
        </div>
        <div :class="'marginC darkMode '+(isOpen?'':'willHide')" style="margin-top: 4px">
          <div class="darkMode">
            <span class="price darkMode">{{ $t("margin") }}</span>
            <span
                class="priceV darkMode">{{ marginLimit }} {{ tokenInfo.symbol }}</span>
          </div>
          <div class="closeC darkMode">
            <span class="price darkMode">{{ $t("margin") }}</span>
            <span
                class="priceV darkMode">{{ marginLimit }} {{ tokenInfo.symbol }}</span>
          </div>
        </div>

      </div>
    </div>

    <div class="limitC darkMode" v-show="marketType==1">
      <div class="titleC darkMode">
        <div class="avaTitle darkMode">
          {{$t('current_price')}}
          <span class="avaValue darkMode">{{ currentPrice }}</span>
        </div>
      </div>
      <div class="amountC darkMode downlist">
        <drawer_list :title="$t('trading_pair')" width="60px" :change-title="false" :on-select="(item,key)=>this.changeUnderline(item,1)" :list="['BTC','ETH','SOL']" :default-select="0" ></drawer_list>
        <div class="amountContent">{{marketUnderline}}</div>
      </div>
      <div class="amountC darkMode">
<!--        <div class="title">{{ isOpen ? $t("open_quantity") : $t("close_quantity") }}</div>-->
        <input class="amountIn darkMode" :placeholder='isOpen ? $t("open_quantity") : $t("close_quantity")' value="" v-model="marketAmount" @focus="getFocus(2)"/>
        <span class="amountTitle darkMode">{{ underling }}</span>
      </div>
      <draggable-progress v-model="progressMarket" :content="['0','100%']"/>

      <div :class="'buySellNotice darkMode '+(showMarketProgressNum?'':'willHide')">
        <div class="item darkMode">
          <div><span>{{ isOpen ? $t("openable") : $t("closable") }}</span><span
              class="span darkMode">{{ isOpen ? marketAmountNumber : transBig2number(closeLongAmountMarket) }}</span>
          </div>
        </div>
        <div class="item darkMode">
          <div>{{ isOpen ? $t("openable") : $t("closable") }}<span
              class="span darkMode">{{ isOpen ? marketAmountNumber : transBig2number(closeShortAmountMarket) }}</span>
          </div>
        </div>
      </div>

      <div class="confirmBox darkMode">
        <input class="confirmBuy darkMode" type="submit" :value="isOpen?$t('go_long'):$t('close_long')"
               @click="open(true,false)"/>
        <input class="confirmSell darkMode" type="submit" :value="isOpen?$t('go_short'):$t('close_short')"
               @click="open(false,false)"/>
      </div>

      <div class="priceC darkMode">
        <div class="priceCC darkMode">
          <div class="openCdarkMode">
            <span class="price darkMode">{{ isOpen ? $t("max_openable") : $t("max_closable") }}</span>
            <span
                class="priceV darkMode">{{ isOpen ? maxMarket : transBig2number(maxLong) }} {{ underling }}</span>
          </div>
          <div class="closeC darkMode">
            <span class="price darkMode">{{ isOpen ? $t("max_openable") : $t("max_closable") }}</span>
            <span
                class="priceV darkMode">{{ isOpen ? maxMarket : transBig2number(maxShort) }} {{ underling }}</span>
          </div>
        </div>
        <div :class="'marginC darkMode '+(isOpen?'':'willHide')">
          <div class=" darkMode">
            <span class="price darkMode">{{ $t("margin") }}</span>
            <span class="priceV darkMode">{{ marginMarket }}</span>
          </div>
          <div class="closeC darkMode">
            <span class="price darkMode">{{ $t("margin") }}</span>
            <span class="priceV darkMode">{{ marginMarket }}</span>
          </div>
        </div>

      </div>
    </div>

    <div class="limitC darkMode" v-show="marketType==2">
      <div class="titleC darkMode">
        <div class="avaTitle darkMode">{{$t('current_price')}}
          <span class="avaValue darkMode">{{currentPrice}}</span>
        </div>
      </div>
      <div class="amountC darkMode downlist">
        <drawer_list :title="$t('trading_pair')" width="60px" :change-title="false" :on-select="(item,key)=>this.changeUnderline(item,2)" :list="['BTC','ETH','SOL']" :default-select="0" ></drawer_list>
        <div class="amountContent">{{targetUnderline}}</div>
      </div>
      <div class="amountC darkMode downlist">
        <drawer_list width="100%" :title="$t('tp_sl_direction')" :change-title="true" :on-select="(item,key)=>v3_direction=key+1" :list="[$t('one_side_tp_sl'),$t('both_sides_tp_sl')]" :default-select="0"></drawer_list>
      </div>

      <div v-if="v3_direction==1">
        <div class="inputC darkMode">
          <div class="inputCC darkMode">
            <input class="input darkMode"  :placeholder="$t('trigger_price')" min="0" v-model="targetPrice" type="number"/>
            <span class="unit darkMode">USD</span>
          </div>
        </div>

        <div class="inputC darkMode downlist">
          <div class="inputCC darkMode">
            <drawer_list width="80px" :title="$t('order_type')" :list="[$t('market_order2'),$t('limit_order2')]" :default-select="0" :on-select="(item,key)=>targetType=(key+1)"/>
            <span v-if="targetType==1" class="amountTitle darkMode">{{$t('market_order')}}</span>
            <input v-if="targetType==2" class="input darkMode right" min=0 v-model="targetLimitPrice" type="number"/>
            <span v-if="targetType==2" class="unit darkMode">USD</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="inputC darkMode">
          <div class="inputCC darkMode">
            <input class="input darkMode" :placeholder="$t('take_profit_trigger_price')" min="0" v-model="targetWinPrice" type="number"/>
            <span class="unit darkMode">USD</span>
          </div>
        </div>

        <div class="inputC darkMode downlist">
          <div class="inputCC darkMode">
            <drawer_list width="80px" :title="$t('order_type')" :list="[$t('market_order2'),$t('limit_order2')]" :default-select="0" :on-select="(item,key)=>targetWinType=(key+1)"/>
            <span v-if="targetWinType==1" class="amountTitle darkMode">{{$t('market_order')}}</span>
            <input v-if="targetWinType==2" class="input darkMode right" min=0 v-model="targetLimitWinPrice" type="number"/>
            <span v-if="targetWinType==2" class="unit darkMode">USD</span>
          </div>
        </div>

        <div class="inputC darkMode">
          <div class="inputCC darkMode">
            <input class="input darkMode" :placeholder="$t('stop_loss_trigger_price')" min="0" v-model="targetLossPrice" type="number"/>
            <span class="unit darkMode">USD</span>
          </div>
        </div>

        <div class="inputC darkMode downlist">
          <div class="inputCC darkMode">
            <drawer_list width="80px" :title="$t('order_type')" :list="[$t('market_order2'),$t('limit_order2')]" :default-select="0" :on-select="(item,key)=>targetLossType=(key+1)"/>
            <span v-if="targetLossType==1" class="amountTitle darkMode">{{$t('market_order')}}</span>
            <input v-if="targetLossType==2" class="input darkMode right" min=0 v-model="targetLimitLossPrice" type="number"/>
            <span v-if="targetLossType==2" class="unit darkMode">USD</span>
          </div>
        </div>
      </div>

      <div class="amountC darkMode">
        <input class="amountIn darkMode" :placeholder="$t('quantity')" v-model="targetAmount" @focus="getFocus(3)"
        />
        <span class="amountTitle darkMode">{{targetUnderline}}</span>
      </div>
      <draggable-progress v-model="v3_progress_target" :content="['0','100%']"/>

      <div class="buySellNotice">
        <div class="item">
          <div><span>{{ $t("closable") }}</span><span
              class="span">{{transBig2number(v3_close_long_target)}}</span>
          </div>
        </div>
        <div class="item">
          <div>{{ $t("closable") }}<span
              class="span">{{transBig2number(v3_close_short_target)}}</span>
          </div>
        </div>
      </div>

      <div class="confirmBox">
        <input class="confirmBuy" type="submit" @click="open(true,false)"
               :value="$t('close_long')"
        />
        <input class="confirmSell" type="submit" @click="open(false,false)"
               :value="$t('close_short')"
        />
      </div>
    </div>


    <el-dialog :visible.sync="levelVisible" :title="$t('adjust_leverage')" width="300px">
      <div class="level_content">
        <div class="level_title">{{ $t("leverage") }}</div>
        <div class="level">
          <div class="level_add" @click="changeLevelNum(1)">-</div>
          <div class="level_num">{{ changeLevel }}x</div>
          <div class="level_sub" @click="changeLevelNum(2)">+</div>
        </div>
        <draggable-progress v-model="changeLevel" :units="'x'" :content="['1x','25x','50x','75x','100x']"/>
        <div class="level_confirm" @click="doChangeLevel">{{ $t('confirm') }}</div>
      </div>
    </el-dialog>
    <el-dialog :modal="false" :title="tokenInfo.symbol+'/'+underling"
               :visible.sync="dialogVisible" width="300">
      <div class="dialog_title"><span class="more" v-if="this.isLong">{{marketType==2?($t('take_profit_stop_loss')+"-"):""}} {{ isOpen ? $t('long_position') : $t('close_long') }}</span>
        <span
            v-if="!this.isLong" class="less">{{marketType==2?($t('take_profit_stop_loss')+"-"):""}} {{ isOpen ? $t("short_position") : $t('close_short') }}</span></div>
      <div>
        <div class="dialog_list" v-if="marketType==0 || marketType==1">
          <div class="left">{{ $t("price") }}</div>
          <div class="right">{{ marketType == 0 ? this.limitPrice : $t('market_order') }}</div>
        </div>
        <div class="dialog_list">
          <div class="left">{{ $t('quantity') }}</div>
          <div class="right">
            <span v-if="isOpen">
              <span v-if="marketType==0">{{this.limitAmountNumber}}</span>
              <span v-if="marketType==1">{{this.marketAmountNumber}}</span>
            </span>
            <span v-else>
              <span v-if="marketType==0">{{transBig2number(isLong ? closeLongAmountLimit : closeShortAmountLimit)}}</span>
              <span v-if="marketType==1">{{transBig2number(isLong ? closeLongAmountMarket : closeShortAmountMarket)}}</span>
              <span v-if="marketType==2">{{transBig2number(isLong?v3_close_long_target:v3_close_short_target)}}</span>
            </span>
          </div>
        </div>


        <div class="dialog_list" v-if="marketType==2 && !isOpen">
          <div class="left">{{$t("type")}}</div>
          <div class="right">{{ this.v3_direction == 1 ? $t("one_side") : $t("both_sides") }}</div>
        </div>
        <div class="dialog_list" v-if="marketType==2 && v3_direction==1 && !isOpen">
          <div class="left">{{$t('target_price')}}</div>
          <div class="right">{{ this.targetPrice }}</div>
        </div>
        <div class="dialog_list" v-if="marketType==2 && v3_direction==1 && !isOpen">
          <div class="left">{{$t('limit_order2')}}/{{$t('market_order')}}</div>
          <div class="right">{{ targetType == 2 ? this.targetLimitPrice : $t('market_order') }}</div>
        </div>
        <div class="dialog_list" v-if="marketType==2 && v3_direction==2 && !isOpen">
          <div class="left">{{$t('take_profit_trigger_price')}}</div>
          <div class="right">{{ this.targetWinPrice }}</div>
        </div>
        <div class="dialog_list" v-if="marketType==2 && v3_direction==2 && !isOpen">
          <div class="left">{{$t('take_profit_limit')}}/{{$t('market_order')}}</div>
          <div class="right">{{ this.targetWinType == 2 ? this.targetWinPrice : $t('take_profit_market') }}</div>
        </div>
        <div class="dialog_list" v-if="marketType==2 && v3_direction==2 && !isOpen">
          <div class="left">{{$t('stop_loss_trigger_price')}}</div>
          <div class="right">{{ this.targetLossPrice }}</div>
        </div>
        <div class="dialog_list" v-if="marketType==2 && v3_direction==2 && !isOpen">
          <div class="left">{{$t('stop_loss_limit')}}/{{$t('market_order')}}</div>
          <div class="right">{{ this.targetLossType == 2 ? this.targetLossPrice : $t('stop_loss_market') }}</div>
        </div>

        <div :class="'dialog_list '+(isOpen?'':'willHide')">
          <div class="left">{{ $t("margin") }}</div>
          <div class="right">{{ this.marketType == 0 ? this.marginLimit : this.marginMarket }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="background: #C6FE61;color: #181A20" type="primary"
                   @click="ok1()">{{ $t("confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DraggableProgress from "./DraggableProgress.vue";
import {
  createLeadingContractAndSend,
  createOrderBookAndCall,
  createPerpOptionAndCall,
  createTradeAndCall,
  getContractOrder,
  getGasReward,
  getSelectTokenInfo
} from "../utils/contract";
import {Method} from "../config/const";
import {transBig2number, transNumber2Big} from "../utils/functions";
import {getLastPrice, registerService, removeService} from "../service/priceService";
import {nextTick} from "vue";
import {BigNumber, ethers} from "ethers";
import {emmitMessageWithDelay, MESSAGE} from "../utils/message";
import Drawer_list from "./templates/drawer_list.vue";

export default {
  components: {Drawer_list, DraggableProgress},
  props: {
    token: "",
    contractAddress: ""
  },
  data() {
    return {
      marketType: 0,//0限价 1市价
      levelVisible: false,
      levelMap: {
        BTC:100,
        ETH:100,
        SOL:100
      },
      changeLevel: 100,
      optionAddress: "",
      marginLimit: "0",
      marginMarket: "0",
      underling: "BTC",
      isOpen: true, //开仓 or 平仓
      accountInfo: {
        available: "0"
      },
      tokenInfo: {
        symbol: "",
        address: ""
      },
      limitPrice: "",
      currentPrice: "",
      limitAmount: "",
      tradeAgent: "",
      viewInit: false,
      maxLimit: "",
      progressLimit: 0,
      progressMarket: 0,
      limitAmountNumber: "",
      marketAmountNumber: "",
      showLimitProgressNum: false,
      showMarketProgressNum: false,
      v3TargetProgressNum:false,
      maxMarket: "0",
      marketAmount: "",

      maxShort: BigNumber.from(0),
      maxLong: BigNumber.from(0),
      positions: {},
      limitPositions: [],
      closeLongAmountLimit: BigNumber.from(0),
      closeShortAmountLimit: BigNumber.from(0),
      closeLongAmountMarket: BigNumber.from(0),
      closeShortAmountMarket: BigNumber.from(0),
      dialogVisible: false,
      isLong: false,
      isLimit: false,
      estimateLimit: "0",
      estimateMarket: "0",
      priceType0: 0,
      triggerPrice: "0",
      execPrice: "0",
      triggerPrice2: "0",
      execPrice2: "0",
      showNumber: "0",
      v3_direction:1,
      v3_directions:[
        {label:this.$t('one_side'),value:1},
        {label:this.$t('both_sides'),value:2}
      ],
      v3_entrust_types:[
        {label:this.$t('market_order2'),value:1},
        {label:this.$t('limit_order2'),value:2}
      ],
      targetType:1, //1 市价 2 限价
      targetWinType:1, //1 市价止盈 2 限价
      targetLossType:1, //1 市价止损 2 限价
      v3_progress_target:0,
      v3_show_number:"0",
      v3_close_long_target:BigNumber.from(0),
      v3_close_short_target:BigNumber.from(0),
      targetAmount:"",
      targetPrice:"",
      targetLimitPrice:"",
      targetWinPrice:"",
      targetLimitWinPrice:"",
      targetLossPrice:"",
      targetLimitLossPrice:"",
      positionCache:undefined,
      limitUnderline:"BTC",
      marketUnderline:"BTC",
      targetUnderline:"BTC"
    }
  },
  methods: {
    transBig2number,
    openLevel(type) {
      this.levelVisible = true;
      this.changeLevel=this.levelMap[this.underling]
    },
    async doChangeLevel() {
      this.levelVisible = false;

      if (!this.optionAddress) {
        return;
      }
      await createLeadingContractAndSend(this.contractAddress, Method.setUserLeverage, [this.underling, this.changeLevel], 0)
      this.levelMap[this.underling]=this.changeLevel
      this.getLevelInfo()
    },
    async getLevelInfo() {
      let selectInfo = await getSelectTokenInfo(this.token)
      this.optionAddress = selectInfo.perpetual;
      if (!this.optionAddress) {
        return;
      }
      let levelBTC = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage,this.token, this.contractAddress, "BTC");
      let levelETH = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage,this.token, this.contractAddress, "ETH");
      let levelSOL = await createPerpOptionAndCall(this.optionAddress, Method.getUserLeverage,this.token, this.contractAddress, "SOL");

      this.levelMap.BTC= parseInt(levelBTC.toString())
      this.levelMap.ETH= parseInt(levelETH.toString())
      this.levelMap.SOL= parseInt(levelSOL.toString())
    },
    async getInfo() {
      let tokenInfo = await getSelectTokenInfo(this.token)
      this.tokenInfo.symbol = tokenInfo.symbol;
      this.optionAddress = tokenInfo.perpetual;

      let accountInfo = await createPerpOptionAndCall(this.optionAddress, Method.getAccountInfo,this.token, this.contractAddress);
      this.accountInfo.available = transBig2number(accountInfo.availableAmount)
      this.tradeAgent = tokenInfo.tradeAgent;
      this.getMax(1)
      this.getMax(2)
    },
    open(isLong, limit) {
      this.dialogVisible = true;
      this.isLong = isLong;
      this.isLimit = limit;
    },
    async updatePrice(priceData) {
      if (!priceData) {
        return;
      }
      if (!this.viewInit) {
        return;
      }
      let currPrice = transBig2number(priceData[this.underling].price, priceData[this.underling].decimal);
      this.currentPrice = currPrice;


      // if (!this.limitPrice) {
      //   this.limitPrice = currPrice;
      //   this.getMax(1)
      // }
      if(this.limitPrice){
        this.getMax(1)
      }
      this.getMax(2)
    },
    async getMax(type) {
      if (!this.tradeAgent) {
        return;
      }
      if(!this.viewInit){
        return;
      }
      let price = ""
      if (type == 1) {
        if (!this.limitPrice) {
          return;
        }
        price = transNumber2Big(this.limitPrice);
      } else {
        let priceData = await getLastPrice();
        let nowPrice = transBig2number(priceData[this.underling].price, priceData[this.underling].decimal);
        price = transNumber2Big(nowPrice)
      }
      let max = await createTradeAndCall(this.tradeAgent, Method.getMaxAmount,this.token, this.contractAddress, this.underling, price);
      if (type == 1) {
        this.maxLimit = transBig2number(max);
      } else {
        this.maxMarket = transBig2number(max);
      }
    },
    async setLimitMax() {
      this.progressLimit = 100;
      await nextTick();
      this.limitAmount = this.maxLimit;
    },

    async estimateMargin(type) {
      let price = await getLastPrice()
      //限价
      if (type == 1) {
        this.marginLimit = (parseFloat(transBig2number(price[this.underling].price, price[this.underling].decimal)) * Number(this.limitAmountNumber) / this.levelMap[this.underling]).toFixed(2);
      } else {
        this.marginMarket = (parseFloat(transBig2number(price[this.underling].price, price[this.underling].decimal)) * Number(this.marketAmountNumber) / this.levelMap[this.underling]).toFixed(2);
      }
    },
    async getFocus(type) {
      if (type == 1) {
        this.progressLimit = 0
        await nextTick();
        this.limitAmount = "";
        this.limitAmountNumber = "0";
      } else if(type==2){
        this.progressMarket = 0;
        await nextTick()
        this.marketAmount = "";
        this.marketAmountNumber = "0";
      }else if(type==3){
        this.v3_progress_target=0;
        await nextTick();
        this.v3_show_number="";
        this.v3_target_number="0";
      }
    },
    async getPositions() {
      if (!this.contractAddress) {
        return;
      }
      let selectToken = await getSelectTokenInfo(this.token);
      let orders = await getContractOrder(this.token,this.contractAddress, selectToken.orderBook);
      this.positionCache=orders;

      let orderIds = await createOrderBookAndCall(selectToken.orderBook, Method.getUserLimitOrdersID,this.token, this.contractAddress)
      let limitOrder = await createTradeAndCall(selectToken.tradeAgent, Method.getLimitOrders, orderIds)

      let maxOpen = orders[this.underling + "_1"].size
      let maxClose = orders[this.underling + "_2"].size

      console.log("get max close",maxOpen.toString(),maxClose.toString(),this.underling,orders);

      for (let i in limitOrder) {
        let item = limitOrder[i];
        if (item.offset === 1) {
          continue;
        }
        if (item.name != this.underling) {
          continue;
        }
        if (item.direct == 1) {
          maxOpen = maxOpen.sub(item.amount)
        } else {
          maxClose = maxClose.sub(item.amount)
        }
      }
      this.maxLong = maxOpen
      this.maxShort = maxClose



    },
    ok1() {
      this.dialogVisible = false
      if (this.marketType == 0) {
        this.trade(this.isLong,true,this.isOpen?1:2)
      } else if(this.marketType==1){
        this.trade(this.isLong,false,this.isOpen?1:2)
      }else{
        this.otcTrade(this.isLong)
      }

    },

    /**
     * @param isBuy 多或空 true 多 false 空
     * @param isLimit 是否限价 true 是 false 否
     * @param offset 1 开仓 2平仓
     * */
    async trade(isBuy, isLimit, offset) {
      //初始化参数
      let num = BigNumber.from(0);
      let value = this.underling;
      let price = 0;

      let prices = await getLastPrice();
      let priceData = transBig2number(prices[this.underling].price, prices[this.underling].decimal);
      let orderType2 = 0;
      if(isLimit){
        if(offset==1){
          num=BigNumber.from(transNumber2Big(this.limitAmountNumber))
        }else{
          num=isBuy?this.closeLongAmountLimit:this.closeShortAmountLimit
        }
        price=BigNumber.from(transNumber2Big(priceData));
      }else{
        if(offset==1){
          num=BigNumber.from(transNumber2Big(this.marketAmountNumber))
        }else{
          num=isBuy?this.closeLongAmountMarket:this.closeShortAmountMarket
        }


        if(offset==1 && isBuy){ //开仓 多
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(105)).div(BigNumber.from(100));
        }else if(offset==1 && !isBuy){//开仓 空
          price="1";
        }else if(offset==2 && isBuy){//平仓 多
          price="1";
        }else if(offset==2 && !isBuy){
          price = BigNumber.from(transNumber2Big(priceData)).mul(BigNumber.from(110)).div(BigNumber.from(100));
        }
        orderType2=21;
      }

      if (num.lte(BigNumber.from(0))) {
        await this.$message.error(this.$t("quantityMustBePositive"))
        return;
      }
      this.$store.commit('setLoading', true)
      setTimeout(() => {
        this.$store.commit('setLoading', false)
      }, 30000)

      let tigger = await getGasReward(this.token, this.underling);


      const tx = await createLeadingContractAndSend(
          this.contractAddress, Method.trade,
          [
            value,
            num.toString(),
            price.toString(),
            1,
            offset,
            isBuy ? 1 : 2,
            orderType2,
            parseInt(new Date().getTime() / 1000) + 31536000,
            ethers.utils.arrayify("0x"),
          ], tigger);

      emmitMessageWithDelay({msg: MESSAGE.POSITION_UPDATE, delay: 5000})

      if (tx) {
        this.$store.commit('setLoading', false)
        this.$emit("refresh-data");
        this.getInfo()
      }

    },

    async otcTrade(isBuy) {//otc 平仓

      //设定参数
      let name = this.underling;
      let amount = isBuy?this.v3_close_long_target:this.v3_close_short_target;
      let offset = 2;
      let direct = isBuy ? 1 : 2
      let param1 = "0";
      let param2 = "0";
      let param3 = "0";
      let param4 = "0";

      if (!this.positionCache) {
        this.$message.error(this.$t('data_return_incorrect'));
        return;
      }

      if (this.v3_direction == 1) { // 1单向 2双向
        let targetPriceBig = transNumber2Big(this.targetPrice)

        if(isBuy && parseFloat(this.targetPrice) >= this.positionCache[this.underling + "_1"].price){
          param1 = targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param2 = transNumber2Big(this.targetLimitPrice)
          }
        }else if(isBuy &&  parseFloat(this.targetPrice) < this.positionCache[this.underling + "_2"].price){
          param3=targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param4 = transNumber2Big(this.targetLimitPrice)
          }
        }else if(!isBuy && parseFloat(this.targetPrice) <= this.positionCache[this.underling + "_1"].price){
          param1 = targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param2 = transNumber2Big(this.targetLimitPrice)
          }
        }else if(!isBuy && parseFloat(this.targetPrice) > this.positionCache[this.underling + "_2"].price){
          param3=targetPriceBig;
          if (this.targetType == 2) { // 1 市价止盈，2限价止盈
            param4 = transNumber2Big(this.targetLimitPrice)
          }
        }

        // if ((isBuy && parseFloat(this.targetPrice) >= this.positionCache[this.underling + "_1"].price) || (!isBuy && parseFloat(this.targetPrice) < this.positionCache[this.underling + "_2"].price)) {//平多
        //   param1 = targetPriceBig;
        //   if (this.targetType == 2) { // 1 市价止盈，2限价止盈
        //     param2 = transNumber2Big(this.targetLimitPrice)
        //   }
        // } else if ((isBuy && parseFloat(this.targetPrice) < this.positionCache[this.underling + "_1"].price) || (!isBuy && parseFloat(this.targetPrice) >= this.positionCache[this.underling + "_2"].price)) {
        //   param3 = targetPriceBig;
        //   if (this.targetType == 2) { // 1 市价止盈，2限价止盈
        //     param4 = transNumber2Big(this.targetLimitPrice)
        //   }
        // }

      } else if (this.v3_direction == 2) {

        if (!this.targetWinPrice) {
          this.$message.error(this.$t('tp_price_must_gt_zero'))
          return;
        }
        if (!this.targetLossPrice) {
          this.$message.error(this.$t('sl_price_must_gt_zero'))
          return;
        }

        if (isBuy && parseFloat(this.targetWinPrice) <= this.positionCache[this.underling + "_1"].price) {
          this.$message.error(this.$t('long_tp_should_gt_cost'))
          return;
        }
        if (isBuy && parseFloat(this.targetLossPrice) >= this.positionCache[this.underling + "_1"].price) {
          this.$message.error(this.$t('long_sl_should_lt_cost'))
          return;
        }
        if (!isBuy && parseFloat(this.targetWinPrice) >= this.positionCache[this.underling + "_2"].price) {
          this.$message.error(this.$t('short_tp_should_lt_cost'))
          return;
        }
        if (!isBuy && parseFloat(this.targetLossPrice) <= this.positionCache[this.underling + "_2"].price) {
          this.$message.error(this.$t('short_sl_should_gt_cost'))
          return;
        }

        param1 = transNumber2Big(this.targetWinPrice)
        param3 = transNumber2Big(this.targetLossPrice)

        if (this.targetWinType == 2) {
          if (!this.targetLimitWinPrice) {
            this.$message.error(this.$t('tp_limit_cannot_empty'));
            return;
          }
          param2 = transNumber2Big(this.targetLimitWinPrice)
        }

        if (this.targetLossType == 2) {
          if (!this.targetLimitLossPrice) {
            this.$message.error(this.$t('sl_limit_cannot_empty'));
            return;
          }
          param4 = transNumber2Big(this.targetLimitLossPrice)
        }

      }

      this.$store.commit('setLoading', true)
      setTimeout(() => {
        this.$store.commit('setLoading', false)
      }, 30000)


      try {
        let tigger = await getGasReward(this.token, this.underling);
        let tx = await createLeadingContractAndSend(this.contractAddress, Method.ocoTrade, [
          name,
          amount.toString(),
          offset,
          direct,
          param1,
          param2,
          param3,
          param4,
          parseInt(new Date().getTime() / 1000) + 31536000
        ], BigNumber.from(tigger).mul(BigNumber.from(2)).toString())
        emmitMessageWithDelay({msg: MESSAGE.POSITION_UPDATE, delay: 5000})
      } catch (e) {
        this.$store.commit('setLoading', false)
        console.log("error is", e);
        this.getInfo()
      }
    },



    async changeLevelNum(type) {
      if (type == 1) {
        this.changeLevel--;
      } else if (type == 2) {
        this.changeLevel++;
      }
    },
    async changeUnderline(underline,type){
      if(type==0){
        this.limitUnderline=underline;
      }else if(type==1){
        this.marketUnderline=underline;
      }else{
        this.targetUnderline=underline
      }
      this.underling=underline;
      this.getPositions()
      this.updatePrice(await getLastPrice())
    },
    updateLevelInfo(){

    }
  },
  created() {
    this.getInfo()
    this.getPositions()
    this.getLevelInfo()
  },
  mounted() {
    this.viewInit=true;
    registerService( this.updatePrice)
  },
  unmounted() {
    this.viewInit=false;
    removeService(this.updatePrice)
  },
  watch: {
    limitPrice(val) {
      this.getMax(1)
    },
    limitAmount(val) {
      this.showLimitProgressNum = val.indexOf("%") !== -1;
      if (!this.showLimitProgressNum) {
        this.limitAmountNumber = val;
      }
      if (!this.isOpen && !isNaN(Number(val))) {
        let closeBig = BigNumber.from(transNumber2Big(val));

        this.closeLongAmountLimit = closeBig.gt(this.maxLong) ? this.maxLong : closeBig;
        this.closeShortAmountLimit = closeBig.gt(this.maxShort) ? this.maxShort : closeBig;

      }
      this.estimateMargin(1)
    },
    progressLimit(val) {
      this.limitAmount = val + "%";
      if (this.isOpen) {
        if(!this.maxLimit){
          return;
        }
        this.limitAmountNumber = (parseFloat(this.maxLimit) * val / 100).toFixed(2)
        this.estimateMargin(1)
      } else {
        if(this.maxLong){
          this.closeLongAmountLimit = this.maxLong.mul(BigNumber.from(val)).div(BigNumber.from(100))
        }
        if(this.maxShort){
          this.closeShortAmountLimit = this.maxShort.mul(BigNumber.from(val)).div(BigNumber.from(100))
        }
      }

    },
    marketAmount(val) {
      this.showMarketProgressNum = val.indexOf("%") !== -1;
      if (!this.showMarketProgressNum) {
        this.marketAmountNumber = val;
      }

      if (!this.isOpen && !isNaN(Number(val))) {
        let closeBig = BigNumber.from(transNumber2Big(val));
        this.closeLongAmountMarket = closeBig.gt(this.maxLong) ? this.maxLong : closeBig;
        this.closeShortAmountMarket = closeBig.gt(this.maxShort) ? this.maxShort : closeBig;
      }

      this.estimateMargin(2)
    },
    progressMarket(val) {
      this.marketAmount = val + "%";
      if (this.isOpen) {
        this.marketAmountNumber = (parseFloat(this.maxMarket) * val / 100).toFixed(2)
        this.estimateMargin(2)
      } else {
        this.closeLongAmountMarket = this.maxLong.mul(BigNumber.from(val)).div(BigNumber.from(100))
        this.closeShortAmountMarket = this.maxShort.mul(BigNumber.from(val)).div(BigNumber.from(100))
      }
    },
    v3_progress_target(val){
      this.targetAmount = val + "%";
      this.v3_close_long_target = this.maxLong.mul(BigNumber.from(val)).div(BigNumber.from(100))
      this.v3_close_short_target = this.maxShort.mul(BigNumber.from(val)).div(BigNumber.from(100))
    },
    targetAmount(val) {
      this.v3TargetProgressNum = val.indexOf("%") !== -1;
      if (!this.v3TargetProgressNum) {
        this.v3_close_long_target=transNumber2Big(val);
        this.v3_close_short_target=transNumber2Big(val);
      }else{
        let closeBig = BigNumber.from(transNumber2Big(val));
        this.v3_close_long_target = closeBig.gt(this.maxLong) ? this.maxLong : closeBig;
        this.v3_close_short_target = closeBig.gt(this.maxShort) ? this.maxShort : closeBig;
      }
    },
    async marketType(val){
      if(val==0){
        this.underling=this.limitUnderline
      }else if(val==1){
        this.underling=this.marketUnderline
      }else{
        this.underling=this.targetUnderline
      }
      this.maxLong=BigNumber.from(0);
      this.maxShort=BigNumber.from(0);
      this.getPositions()
      this.updatePrice(await getLastPrice())
    }


  }
}

</script>
<style src="../assets/windows.scss" lang="scss" scoped></style>
<style lang="less" scoped>
.contractContainer {
  display: block;
  grid-template-columns: 1fr;
  padding: 16px;
  border-radius: 8px;
  background-color: #ffffff;
  margin-bottom: 200px;
  //box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  &.darkMode {
    background-color: #101014FF;
  }

  .limitC {
    margin-top: 16px;
    margin-bottom: 4px;
  }

  .rate {
    display: flex;
    gap: 8px;
    flex-direction: row;
    align-items: center;
    cursor: pointer;

    .rateItem {
      width: 70px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      font-weight: 700;
      border-radius: 4px;
      text-align: center;
      color: #202630;
      background: rgba(234, 236, 239, 1);

      &.darkMode {
        background: #16171AFF;
        color: #FFFFFFFF;

        &.active {
          background: #26282CFF;
        }
      }
    }
  }

  .openC {
    border-radius: 6px;
    height: 26px;
    margin-top: 19px;
    position: relative;

    .openItem {
      width: 50%;

      .openItemTitle {
        text-align: center;
        display: inline-block;
        line-height: 26px;
        font-size: 12px;
        font-weight: 700;
        width: 100%;
        cursor: pointer;
        color: #202630;

        &.active {
          background: rgba(174, 177, 184, 1);
        }

        &.darkMode {
          color: #FFFFFFFF;

          &.active {
            background: rgba(56, 56, 56, 1);
          }
        }

      }
    }

    .openItemBox {
      height: 20px;
      width: 20px;
      margin-left: -10px;
      position: absolute;
      margin-top: 4px;
      display: inline-block;
      transform: rotate(45deg);
      border-radius: 4px;
      background: rgba(174, 177, 184, 1);

      &.darkMode {
        background: rgba(56, 56, 56, 1);
      }
    }

    .open {
      float: left;

      .openTitle {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        border-left: 1.3px solid #808080;
        border-top: 1.3px solid #808080;
        border-bottom: 1.3px solid #808080;

        &.darkMode {
          border-left: 1.3px solid #808080;
          border-top: 1.3px solid #808080;
          border-bottom: 1.3px solid #808080;

          &.active {
            border-color: #474D57;
          }
        }

        border-right: 0 none;
      }
    }

    .close {
      float: right;

      .closeTitle {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;

        border-right: 1.3px solid #808080;
        border-top: 1.3px solid #808080;
        border-bottom: 1.3px solid #808080;

        &.darkMode {
          border-right: 1.3px solid #808080FF;
          border-top: 1.3px solid #808080FF;
          border-bottom: 1.3px solid #808080FF;

          &.active {
            border-color: #474D57;
          }
        }

        border-left: 0 none;
      }

    }

  }

  .openType {
    margin-top: 20px;
    border-bottom: 1px solid #D9D9D9;
    display: flex;
    flex-direction: row;
    padding-bottom: 4px;

    &.darkMode {
      border-bottom: 1px solid #2B3139FF;
    }

    .type {
      font-size: 14px;
      font-weight: 700;
      margin-right: 32px;
      cursor: pointer;
      color: #202630;
      text-decoration: none;
      text-underline-offset: 7px;

      &.active {
        color: #014EFC;
        text-decoration: underline;
        text-decoration-thickness: 3px;
      }

      &.darkMode {
        color: #AEB1B8FF;

        &.active {
          color: #C6FE61FF;
          text-decoration: underline;
          text-decoration-thickness: 3px;
        }
      }
    }
  }

  .titleC {
    display: flex;
    justify-content: space-between;
  }

  .avaTitle {
    font-size: 12px;
    font-weight: 400;
    color: #808080;

    &.darkMode {
      color: #808080;
    }

    .avaValue {
      color: #808080;

      &.darkMode {
        color: #AEB1B8FF
      }
    }
  }

  .addAndSub {
    &.darkMode {
      color: #808080FF;
    }
  }

  .price {
    font-size: 14px;
    font-weight: 500;
    margin-top: 14px;
    color: #808080;

    &.darkMode {
      color: #808080FF;
    }
  }

  .inputC {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    height: 44px;

    .inputCC {
      background: #1D1E22;
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 8px;
      padding-left: 10px;
      padding-right: 10px;
      .title{
        font-size: 14px;
        color:#A7B1C1;
        font-weight: 510;
      }

      .input {
        border: none;
        outline: none;
        height: 40px;
        font-size: 14px;
        font-weight: 500;
        line-height: 40px;
        flex: 1;
        background: transparent;

        &.darkMode {
          color: #FFFFFFFF;
        }
        ::placeholder{
          color: #737D8F;
        }
      }

      .unit {
        font-size: 15px;
        font-weight: 500;
        line-height: 40px;
        color: #202630;

        &.darkMode {
          color: #737D8F;
        }
      }

    }

    .newPrice {
      width: 94px;
      height: 44px;
      border-radius: 8px;
      text-align: center;
      font-size: 15px;
      font-weight: 500;
      line-height: 44px;
      margin-left: 10px;
      cursor: pointer;
      color: #202630;
      background: #1D1E22;

      &.darkMode {
        color: #FFFFFFFF;
      }
    }
  }

  .amountC {
    height: 44px;
    border-radius: 8px;
    background: #1D1E22;
    padding-left: 13px;
    padding-right: 13px;
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 12px;
    .amountContent{
      color: #737D8F;
      font-family: "SF Pro";
      font-size: 14px;
      font-style: normal;
      font-weight: 590;
      line-height: normal;
    }

    .title{
      font-size: 14px;
      color:#737D8F !important;
      font-weight: 510;
    }

    .amountIn {
      background: transparent;
      outline: none;
      border: none;
      flex: 1;
      font-size: 14px;
      color: #014EFC;
      padding-right: 10px;
      font-weight: 500;

      &.darkMode {
        color: #fff;
      }
      ::placeholder{
        color: #737D8F;
      }
    }

    .amountTitle {
      color: #737D8F !important;
      font-size: 14px;
      font-family: "SF Pro";
      font-weight: 590;
      line-height: 44px;
    }
  }

  .buySellNotice {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    margin-bottom: 12px;

    .item {
      font-size: 12px;
      font-weight: 500;
      color: #808080;

      &.darkMode {
        color: #808080FF;
      }

      .span {
        margin-left: 5px;
        color: #808080;

        &.darkMode {
          color: #E5E5E5FF;
        }
      }
    }
  }

  .confirmBox {
    display: flex;
    flex-direction: row;
    //margin-top: 24px;
    font-size: 14px;
    font-weight: 700;

    .confirmBuy {
      width: 154px;
      height: 36px;
      opacity: 1;
      border-radius: 6px;
      background: rgba(32, 178, 108, 1);
      color: white;
      border: none;
      flex: 1;

    }

    .confirmSell {
      width: 154px;
      height: 36px;
      opacity: 1;
      border-radius: 6px;
      background: rgba(239, 69, 74, 1);
      color: white;
      border: none;
      flex: 1;
      margin-left: 16px;
    }

    .confirmDisable {
      cursor: not-allowed;
      opacity: 20%;
    }

  }

  .priceC {
    margin-top: 16px;

    .priceCC {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .price {
        font-weight: 400;
        font-size: 12px;
        color: #808080FF;
      }

      .priceV {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
        margin-left: 5px;

        &.darkMode {
          color: #E5E5E5FF;
        }
      }
    }

    .bottom {
      height: 1px;
      background: #2B3139FF;
      margin-top: 20px;
    }
  }


}

.depositCC {
  border-radius: 8px;
  background: #fff;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;

  &.darkMode {
    background: #101014FF;
  }

  .securityT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;

    .securityRate {
      font-size: 16px;
      font-weight: 700;
      color: #333333;

      &.darkMode {
        color: #E5E5E5FF;
      }
    }

    .securityRateC {
      display: flex;

      img {
        width: 14px;
        height: 14px;
      }

      span {
        font-size: 12px;
        color: #20B26CFF;
        font-weight: 500;
        margin-left: 3px;
      }
    }

  }

  .securityVC {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;

    .securityVT {
      font-size: 12px;
      color: #808080FF;
      font-weight: 400;
    }

    .securityVV {
      font-size: 12px;
      color: #333;
      font-weight: 400;

      &.darkMode {
        color: #E5E5E5FF;
      }
    }
  }

  .depositAC {
    display: flex;
    gap: 10px;
    margin-top: 11px;

    .item {
      height: 34px;
      flex: 1;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 700;
      text-align: center;
      line-height: 34px;
      cursor: pointer;
    }

    .depositD {
      background: #014EFC;
      color: #FFFFFF;
      display: block;

      &.darkMode {
        background: #C6FE61FF;
        color: #383838FF;
      }
    }

    .depositW {
      background: #FFFFFF;
      color: #014EFC;
      border: 1px solid #014EFC;

      &.darkMode {
        background: #414347FF;
        color: #E5E5E5FF;
        border: none;
      }
    }
  }
}

.depositC {
  height: 44px;
  background: #F6F7F9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding-left: 16px;
  padding-right: 16px;

  &.darkMode {
    background: #26282CFF;
  }

  .deposit {
    background: transparent;
    border: none;
    flex: 1;
    outline: none;
    font-size: 15px;
    font-weight: 500;

    &.darkMode {
      color: #E5E5E5FF;
    }
  }

  .deposit:hover {
    border: none;
  }

  .depositTitle {
    color: #808080FF;
    font-weight: 700;
    font-size: 14px;
  }

  .pointer {
    cursor: pointer;
  }
}

.confirm {
  margin-top: 20px;
  display: block;
  width: 100%;
  height: 44px;
  font-size: 14px;
  background: #014EFC;
  color: #FFFFFF;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  line-height: 44px;
  font-weight: 700;

  &.darkMode {
    background: #C6FE61FF;
    color: #383838FF
  }
}

.willHide {
  //visibility: hidden !important;
  display: none !important;
}

.priceSpan {
  color: #A6A6A6;
  font-size: 13px;
  font-weight: 500;
}

.priceNote {
  color: rgba(239, 69, 74, 1);
}

.long {
  color: #20b26c;
}

.short {
  color: #ef454a;
}

.openDialogTitle {
  display: flex;
  justify-content: space-between;

  .title {
    font-size: 22px;
    color: #333;
    font-weight: 700;

    &.darkMode {
      color: white;
    }
  }

  .option {
    height: 16px;
    border-radius: 2px;

    line-height: 16px;
    font-size: 12px;
    text-align: center;

    font-family: "思源黑体";
    margin-left: 2px;
    padding-left: 4px;
    padding-right: 4px;
    color: #333;
    background-color: #E5E5E5FF;

    &.darkMode {
      background-color: rgba(43, 49, 57, 1);
      color: rgba(132, 142, 156, 1);

    }
  }

  .type {
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0px;
    text-align: left;
    color: #1346ff;

    &.darkMode {
      color: rgba(198, 254, 97, 1);
    }
  }

  .close {
    color: white;
  }
}

.level {
  font-size: 14px;

  &.darkMode {
    color: rgba(229, 229, 229, 1);
  }
}

.levelC {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  border: 1px solid #D9D9D9;
  border-radius: 6px;
  font-size: 16px;
  margin-top: 16px;

  &.darkMode {
    color: #E5E5E5FF;
    border: 1px solid #E5E5E5FF;
  }

  padding-left: 16px;
  padding-right: 16px;

}

.slider {
  margin-top: 20px;
}

.levelB {
  height: 44px;
  margin-top: 40px;
  border-radius: 6px;
  font-size: 15px;
  width: 100%;
  display: block;
  font-weight: 700;
  background: #014EFC;
  color: #fff;
  border-color: transparent;

  &.darkMode {
    color: #000000FF;
    background: #C6FE61FF;
  }
}

.pointer {
  cursor: pointer;
}

.level_title {
  color: white;
}

.level {
  display: flex;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 1);
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  color: rgba(128, 128, 128, 1);
  align-items: center;
  font-size: 14px;
  margin-top: 20px;
}

.level_num {
  flex: 1;
  text-align: center;
}

.level_add, .level_sub {
  font-size: 20px;
  cursor: pointer;
}

.level_confirm {
  width: 100%;
  height: 44px;
  margin-top: 40px;
  margin-left: auto;
  border-radius: 8px;
  margin-right: auto;
  border: 1px solid rgba(198, 254, 97, 1);
  background: rgba(198, 254, 97, 1);
  font-size: 15px;
  font-weight: 500;
  color: black;
  line-height: 44px;
  text-align: center;
}

.marginC {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;

  .price {
    font-weight: 400;
    font-size: 12px;
    color: #808080FF;
  }

  .priceV {
    font-weight: 400;
    font-size: 12px;
    color: #E5E5E5;
    margin-left: 5px;
  }
}

.underlingC {
  border: 0.6px solid rgba(56, 56, 56, 1);
  border-radius: 6px;
  height: 54px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .select_down {
    width: 100px;

  }

  .underlingV {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 21.76px;
    color: rgba(239, 69, 74, 1);
    margin-right: 20px;
  }

}

::v-deep .el-dialog {
  background: #1E2329;
  width: 80% !important;
}

::v-deep .el-dialog__title {
  color: #E5E5E5;
}


.select_down ::v-deep .el-input .el-input__inner {
  font-size: 24px !important;
  font-weight: 700;
  letter-spacing: 0px;
  color: rgba(229, 229, 229, 1);
}

.select_down .el-select-dropdown__item {
  font-weight: 700;
  letter-spacing: 0px;
  color: rgba(229, 229, 229, 1);
}

.dark-select {
  --el-select-border-color-hover: #409eff;
  --el-select-input-focus-border-color: #409eff;
}

:deep(.el-select__wrapper) {
  background-color: #1d1e1f; /* 深色背景 */
  box-shadow: 0 0 0 1px #4c4d4f inset; /* 自定义边框 */
}

:deep(.el-select__placeholder) {
  color: #a8abb2;
}

/* 2. 修改下拉弹窗 (需配合 popper-class) */
:global(.dark-select .el-input__inner){
  text-align: center;
}
:global(.entrust_select .el-input__inner){
  text-align: left;
  padding-left: revert;
}

:global(.dark-popper .el-select-dropdown__item.hover) {
  background-color: #262727; /* 悬停颜色 */
}

:deep(.el-select__wrapper) {
  font-size: 14px;       /* 变大 */
  text-align: center;    /* 居中 */
  justify-content: center;
}
:deep(.el-select__placeholder) {
  text-align: center;
  width: 100%;           /* 确保占满宽度以实现居中 */
}
:global(.dark-popper.el-popper) {
  /* 1. 修改下拉框整体背景和边框 */
  background: #1d1e1f !important;
  border: 1px solid #4c4d4f !important;
}

:global(.popper__arrow){
  display: none !important;
}
.downlist{
  height: 36px !important;

}

</style>
